var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "homepage-products area"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("全国领先的互联网金融信息服务提供商")]), _c("h5", [_vm._v("专业、安全、合规")]), _c("a-tabs", {
    attrs: {
      tabBarStyle: {
        "font-family": "AlibabaPuHuiTiM",
        "text-align": "center"
      }
    },
    model: {
      value: _vm.activeKey,
      callback: function ($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, _vm._l(_vm.catalogList, function (item, index) {
    return _c("a-tab-pane", {
      key: index,
      attrs: {
        tab: item.catalog
      }
    }, [_c("FunctionCard2", {
      attrs: {
        list: item.productList,
        isLink: ""
      }
    })], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };